export const Title = 'Timart Ecommerce';
export const domain = 'https://tmart.com.ng';
